<template>
  <div class="container">
    <div class="left">
      <div class="listen">
        <img
          :src="`/icons/spatial-audio-off.svg`"
          style="width: 50%; height: 50%"
          alt=""
        />
      </div>
      <div class="text">
        <p class="title">{{ title }}</p>
        <p class="descrip">{{ descrip }}</p>
      </div>
    </div>
    <div class="right">
      <div class="play" @click="onPlay">
        <img class="img_play" :src="getIconPath(play)" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AudioList',
  props: {
    play: Boolean,
    title: String,
    descrip: String,
  },
  data() {
    return {
      test: false,
    };
  },
  methods: {
    onPlay: function () {
      this.$emit('onPlay');
    },
    getIconPath(status) {
      return status ? '/icons/pause.svg' : '/icons/play-arrow.svg';
    },
  },
  computed: {},
  watch: {},
  created() {
    this.test = this.play;
  },
  mounted() {},
  beforeDestroy() {},
};
</script>

<style scoped>
.container {
  background-color: #1d5bd7;
  width: 100%;
  border-radius: 15px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.left {
  width: 100%;
  height: 7rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}
.play {
  height: 100%;
  /* background-color: red; */
  display: flex;
  align-items: center;
  justify-content: center;
}
.img_play {
  width: 80%;
  /* width: auto; */
  cursor: pointer;
}
.listen {
  background-color: #89abe6;
  border-radius: 5px;
  width: 12%;
  height: 70%;
  display: flex;
  justify-content: center;
  align-self: center;
  align-items: center;
  /* flex-grow: 1 */
}
.text {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: auto;
  width: auto;
  margin-left: 2%;
}
.text p {
  color: white;
  margin: 0;
}

.text p:nth-child(1) {
  font-size: 30px;
}

.text p:nth-child(2) {
  font-size: 15px;
  color: #89abe6;
  text-align: start;
}
.right {
  width: auto;
  height: 100%;
}
@media only screen and (min-width: 300px) and (max-width: 415px) {
  .listen {
    width: auto;
  }
  .text p:nth-child(1) {
    font-size: 20px;
  }
}
/*@media only screen and (min-width: 375px) and (max-width: 415px) {
  .text p:nth-child(1) {
    font-size: 20px;
  }
  .container {
    background-color: #1d5bd7;
    width: 100%;
    height: 100%;
    border-radius: 15px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .listen {
    width: 70%;
    height: 40%;
  }

  .left {
    width: 100%;
    height: 90%;
  }
} */
</style>
